import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';

import VerifyIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';

import Validator, { useValidate, checkValidity } from '../validator';


const useStyles = makeStyles(theme => ({
    select: {
        width: '100%',
    }
}));

const SandboxURL = (props) => {
    const classes = useStyles();
    const [sandbox, setSandbox] = useState({
        type: 'cuckoo',
        url: '',
        apikey: '',
        url_timeout: 11,
        res_wait_timeout: 600
    });
    const sandboxForm = useValidate({});

    useEffect(() => {
        setSandbox(props.sandbox);
    }, []);

    useEffect(() => {
        props.handleUpdate(sandbox, props.index);
    }, [sandbox]);

    const verifyURL = () => {
        props.handleVerify(sandbox);
    }

    const handleUpdate = (e, validID, valid) => {
        if(validID) {
            sandboxForm.set({...sandboxForm.get(), [validID]: valid});
            props.handleValidation(validID, valid);
        }
        setSandbox({
            ...sandbox,
            [e.target.name]: e.target.type === 'number' ? parseInt(e.target.value) : e.target.value,
        });
    };

    const deleteURL = () => {
        props.handleDelete(props.index);
    }

    return (
        <Grid container item spacing={2} xs={12}>
            <Grid item xs={2}>
                <Select variant="standard" disabled={props.disabled} className={classes.select} defaultValue='cuckoo' name="type" value={props.sandbox.type} onChange={props.handleUpdate}>
                    <MenuItem value="cuckoo">cuckoo</MenuItem>
                </Select>
            </Grid>
            <Grid item xs={3}>
                <Validator
                    disabled={props.disabled}
                    valueType="url"
                    errorText="URL is invalid"
                    fullWidth
                    variant="standard"
                    name="url"
                    value={sandbox.url}
                    onChange={handleUpdate}
                    onRemoval={props.handleRemoval}

                />
            </Grid>
            <Grid item xs={3}>
                <TextField
                    disabled={props.disabled}
                    fullWidth
                    variant="standard"
                    name="apikey"
                    value={sandbox.apikey}
                    onChange={handleUpdate}
                />
            </Grid>
            <Grid item xs={2}>
                <Validator
                    disabled={props.disabled}
                    valueType="range"
                    errorText="Timeout must be within 30 and 1800 seconds"
                    fullWidth
                    variant="standard"
                    type="number"
                    inputProps={{
                        min: 30,
                        max: 1800,
                    }}
                    name="res_wait_timeout"
                    value={sandbox.res_wait_timeout}
                    onChange={handleUpdate}
                    onRemoval={props.handleRemoval}
                />
            </Grid>
            {!props.disabled && <Grid item xs={2}>
                <IconButton aria-label="verify" onClick={verifyURL} size="large"><VerifyIcon /></IconButton>
                <IconButton aria-label="delete" color="secondary" onClick={deleteURL} size="large"><DeleteIcon /></IconButton>
            </Grid>}
        </Grid>
    );
};

SandboxURL.propTypes = {
    handleVerify: PropTypes.func.isRequired,
    handleUpdate: PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired,
    sandbox: PropTypes.shape({
        type: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        apikey: PropTypes.string.isRequired,
        url_timeout: PropTypes.number.isRequired,
        res_wait_timeout: PropTypes.number.isRequired,
    }),
};

export default SandboxURL;
